// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { uploadDocuments } from "../../../services/user.services";
// import { retrieveStudentDetails } from "../../../services/admin.services";
// import { setUserDetails } from "../../../state/reducers/userSlice";
// import { Check, File, Plus, Upload, X } from "lucide-react";

// // Enhanced DocumentUpload component
// const DocumentUpload = ({
//   title,
//   description,
//   index,
//   onFileChange,
//   uploadedFile,
//   fileUrl,
// }) => {
//   const fileInputRef = React.useRef(null);

//   const handleClick = () => {
//     fileInputRef.current.click();
//   };

//   const handleFileChange = (e) => {
//     if (e.target.files[0]) {
//       onFileChange(index, e.target.files[0]);
//     }
//   };
//   console.log("fileurl", fileUrl);
//   return (
//     <div className="mt-3">
//       <div
//         onClick={handleClick}
//         className={`border-2 border-dashed rounded-lg p-4 transition-all cursor-pointer
//           ${
//             uploadedFile || fileUrl
//               ? "border-green-500 bg-green-50"
//               : "border-gray-300 hover:border-purple-400 bg-white"
//           }`}
//       >
//         <input
//           type="file"
//           onChange={handleFileChange}
//           className="hidden"
//           ref={fileInputRef}
//         />

//         <div className="flex items-center">
//           {uploadedFile || fileUrl ? (
//             <div className="flex items-center text-green-600">
//               <Check size={20} className="mr-2" />
//               <span className="font-medium">
//                 {uploadedFile ? uploadedFile.name : "File uploaded"}
//               </span>
//             </div>
//           ) : (
//             <div className="flex flex-col items-center w-full py-3 text-gray-500">
//               <Upload size={28} className="mb-2 text-purple-500" />
//               <p className="text-sm font-medium">Click to upload {title}</p>
//               <p className="text-xs mt-1 text-gray-400">
//                 PDF, DOC, or DOCX up to 10MB
//               </p>
//             </div>
//           )}
//         </div>
//       </div>

//       {fileUrl && (
//         <div className="mt-2">
//           <a
//             href={fileUrl}
//             target="_blank"
//             rel="noreferrer"
//             className="text-sm text-purple-600 hover:text-purple-800 flex items-center"
//           >
//             <File size={14} className="mr-1" />
//             View uploaded file
//           </a>
//         </div>
//       )}
//     </div>
//   );
// };

// const FinalDocumentUpload = () => {
//   const user_id = useSelector((state) => state.user.user_id);
//   const socket = useSelector((state) => state.user.socket);
//   const studentDetails = useSelector((state) => state.user.userDetails);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [showDefaultDocs, setShowDefaultDocs] = useState(false); // New state to control when to show default docs
//   const dispatch = useDispatch();

//   // Initial document templates (not added by default)
//   const defaultDocTemplates = [
//     { title: "Transcripts", description: "Upload your finalized transcripts." },
//     {
//       title: "SOP",
//       description: "Upload your finalized Statement of Purpose.",
//     },
//   ];

//   // State for uploaded documents - starts empty
//   const [uploads, setUploads] = useState([]);

//   // Fetch and prepopulate only existing uploaded documents (no defaults)
//   useEffect(() => {
//     let existingDocs = [];

//     if (studentDetails?.final_doc_urls) {
//       existingDocs = Object.entries(studentDetails.final_doc_urls).map(
//         ([title, doc]) => ({
//           id: Math.random(),
//           title,
//           description: doc.description || "Click to edit description",
//           fileUrl: doc.url || null,
//           file: null,
//           editableTitle: false,
//           editableDescription: false,
//         })
//       );
//     }

//     // Only set existing documents, no default ones
//     setUploads(existingDocs);
//   }, []);

//   // Function to add default documents when needed
//   const addDefaultDocuments = () => {
//     const existingTitles = uploads.map((doc) => doc.title);

//     const newDefaultDocs = defaultDocTemplates
//       .filter((template) => !existingTitles.includes(template.title))
//       .map((template) => ({
//         id: Math.random(),
//         title: template.title,
//         description: template.description,
//         fileUrl: null,
//         file: null,
//         editableTitle: false,
//         editableDescription: false,
//       }));

//     if (newDefaultDocs.length > 0) {
//       setUploads((prevUploads) => [...newDefaultDocs, ...prevUploads]);
//       setShowDefaultDocs(true);
//     }
//   };

//   // Fetch user details and update store
//   const getStudentProfile = async () => {
//     try {
//       const res = await retrieveStudentDetails(user_id);
//       dispatch(setUserDetails(res.data));
//       return res.data;
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // Add more documents dynamically
//   const handleAddMore = () => {
//     console.log("Adding custom document...");
//     const newId = Math.random();
//     const currentLength = uploads.length;

//     const newDocument = {
//       id: newId,
//       title: `Document ${currentLength + 1}`,
//       description: "Click to edit description",
//       fileUrl: null,
//       file: null,
//       editableTitle: true,
//       editableDescription: true,
//     };

//     console.log("New document:", newDocument);

//     setUploads((prevUploads) => {
//       const updated = [...prevUploads, newDocument];
//       console.log("Updated uploads after adding custom doc:", updated);
//       return updated;
//     });

//     // Focus on the title input after a short delay to ensure the DOM has updated
//     setTimeout(() => {
//       const titleInput = document.querySelector(
//         `#title-input-${currentLength}`
//       );
//       if (titleInput) {
//         titleInput.focus();
//         titleInput.select(); // Also select the text for easier editing
//       }
//     }, 100); // Increased delay slightly
//   };

//   // Handle file selection
//   const handleFileChange = (index, file) => {
//     setUploads((prevUploads) =>
//       prevUploads.map((upload, i) =>
//         i === index ? { ...upload, file, fileUrl: null } : upload
//       )
//     );
//   };

//   // Handle title change
//   const handleTitleChange = (index, newTitle) => {
//     setUploads((prevUploads) =>
//       prevUploads.map((upload, i) =>
//         i === index ? { ...upload, title: newTitle } : upload
//       )
//     );
//   };

//   // Handle description change
//   const handleDescriptionChange = (index, newDescription) => {
//     setUploads((prevUploads) =>
//       prevUploads.map((upload, i) =>
//         i === index ? { ...upload, description: newDescription } : upload
//       )
//     );
//   };

//   // Enable edit mode - allow editing for non-default docs or if default docs are editable
//   const enableEditMode = (index, field) => {
//     const isDefaultDoc = defaultDocTemplates.some(
//       (template) => template.title === uploads[index]?.title
//     );

//     // Allow editing if it's not a default doc, or if you want to allow editing default docs
//     if (!isDefaultDoc || showDefaultDocs) {
//       setUploads((prevUploads) =>
//         prevUploads.map((upload, i) =>
//           i === index ? { ...upload, [field]: true } : upload
//         )
//       );

//       // For title edits, focus on the input after a short delay
//       if (field === "editableTitle") {
//         setTimeout(() => {
//           const titleInput = document.querySelector(`#title-input-${index}`);
//           if (titleInput) {
//             titleInput.focus();
//           }
//         }, 50);
//       }
//     }
//   };

//   // Exit edit mode
//   const handleBlur = (index, field) => {
//     setUploads((prevUploads) =>
//       prevUploads.map((upload, i) =>
//         i === index ? { ...upload, [field]: false } : upload
//       )
//     );
//   };

//   // Delete a document - don't allow deleting default docs unless specified
//   // const handleDelete = async (index) => {
//   //   const isDefaultDoc = defaultDocTemplates.some(
//   //     (template) => template.title === uploads[index]?.title
//   //   );

//   //   if (!isDefaultDoc) {
//   //     const documentToDelete = uploads[index];

//   //     // If it's just a local file (not uploaded to server), remove from state only
//   //     if (!documentToDelete.fileUrl) {
//   //       setUploads((prevUploads) => prevUploads.filter((_, i) => i !== index));
//   //       return;
//   //     }

//   //     // For uploaded documents, send delete request to server
//   //     try {
//   //       setIsSubmitting(true);

//   //       const formData = new FormData();
//   //       formData.append("document_type", "final_doc");
//   //       formData.append("action", "delete");
//   //       formData.append("document_key", documentToDelete.title);

//   //       const res = await uploadDocuments(formData);
//   //       setSuccessMessage("Document deleted successfully!");
//   //       console.log("Delete Successful:", res);

//   //       // Refresh Redux state and reset UI
//   //       const updatedDetails = await getStudentProfile();
//   //       resetUploadState(updatedDetails);

//   //       setTimeout(() => setSuccessMessage(""), 3000);
//   //     } catch (error) {
//   //       console.error("Error deleting document:", error);
//   //       setSuccessMessage("Failed to delete document.");
//   //       setTimeout(() => setSuccessMessage(""), 3000);

//   //       // Refresh state to restore consistency if deletion failed
//   //       const updatedDetails = await getStudentProfile();
//   //       resetUploadState(updatedDetails);
//   //     } finally {
//   //       setIsSubmitting(false);
//   //     }
//   //   }
//   // };

//   const handleDelete = async (index) => {
//     const documentToDelete = uploads[index];

//     if (!documentToDelete.fileUrl) {
//       // just remove from local state
//       setUploads((prevUploads) => prevUploads.filter((_, i) => i !== index));
//       return;
//     }

//     try {
//       setIsSubmitting(true);

//       const formData = new FormData();
//       formData.append("document_type", "final_doc");
//       formData.append("action", "delete");
//       formData.append("document_key", documentToDelete.title);

//       const res = await uploadDocuments(formData);
//       setSuccessMessage("Document deleted successfully!");

//       const updatedDetails = await getStudentProfile();
//       resetUploadState(updatedDetails);
//       setTimeout(() => setSuccessMessage(""), 3000);
//     } catch (error) {
//       console.error("Error deleting document:", error);
//       setSuccessMessage("Failed to delete document.");
//       setTimeout(() => setSuccessMessage(""), 3000);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // Handle form submission
//   const handleSubmit = async () => {
//     // Use the simpler validation from the first version
//     if (uploads.every((upload) => !upload.file)) {
//       setSuccessMessage(
//         "Please upload at least one new document before submitting."
//       );
//       setTimeout(() => setSuccessMessage(""), 3000);
//       return;
//     }

//     setIsSubmitting(true);
//     const formData = new FormData();
//     formData.append("document_type", "final_doc");

//     // Add extra validation to prevent null/undefined values
//     uploads.forEach((upload) => {
//       if (upload.file && upload.title && upload.description) {
//         formData.append("document_key", upload.title);
//         formData.append("files", upload.file);
//         formData.append("description", upload.description);
//       }
//     });

//     try {
//       const res = await uploadDocuments(formData);
//       setSuccessMessage("Documents uploaded successfully!");
//       console.log("Upload Successful:", res);

//       // Refresh Redux state and reset UI
//       const updatedDetails = await getStudentProfile();
//       resetUploadState(updatedDetails);

//       setTimeout(() => setSuccessMessage(""), 3000);
//     } catch (error) {
//       console.error("Error:", error);
//       setSuccessMessage("Failed to upload documents.");
//       setTimeout(() => setSuccessMessage(""), 3000);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const resetUploadState = (updatedDetails) => {
//     let existingDocs = [];

//     if (updatedDetails?.final_doc_urls) {
//       existingDocs = Object.entries(updatedDetails.final_doc_urls).map(
//         ([title, doc]) => ({
//           id: Math.random(),
//           title,
//           description: doc.description || "Click to edit description",
//           fileUrl: doc.url || null,
//           file: null,
//           editableTitle: false,
//           editableDescription: false,
//         })
//       );
//     }

//     // Only set existing documents, no defaults
//     setUploads(existingDocs);
//     setShowDefaultDocs(false);
//   };

//   const canDeleteDocument = (index) => {
//     return true;
//   };

//   const canEditDocument = (index) => {
//     return true;
//   };

//   return (
//     <div className="bg-white rounded-xl shadow-lg overflow-hidden">
//       {/* Header */}
//       <div className="bg-purple-600 px-6 py-4">
//         <h2 className="text-2xl font-bold text-white">
//           Final Documents Upload
//         </h2>
//         <p className="text-purple-100 text-sm mt-1">
//           Upload your finalized admission documents
//         </p>
//       </div>

//       {/* Success message */}
//       {successMessage && (
//         <div
//           className={`px-6 py-3 mt-4 mx-6 rounded-md ${
//             successMessage.includes("Failed")
//               ? "bg-red-100 text-red-700"
//               : "bg-green-100 text-green-700"
//           }`}
//         >
//           {successMessage}
//         </div>
//       )}

//       {/* Documents list */}
//       <div className="p-6">
//         {/* Add default documents button - only show if no documents exist */}
//         {uploads.length === 0 && (
//           <div className="text-center py-8 border-2 border-dashed border-gray-300 rounded-lg mb-6">
//             <p className="text-gray-500 mb-4">No documents uploaded yet</p>
//             <button
//               onClick={(e) => {
//                 e.preventDefault();
//                 console.log("Default docs button clicked");
//                 addDefaultDocuments();
//               }}
//               className="bg-purple-600 text-white px-4 py-2 rounded-md hover:bg-purple-700 mr-3"
//             >
//               Add Required Documents (Transcripts & SOP)
//             </button>
//             <button
//               onClick={(e) => {
//                 e.preventDefault();
//                 console.log("Custom doc button clicked");
//                 handleAddMore();
//               }}
//               className="border border-purple-600 text-purple-600 px-4 py-2 rounded-md hover:bg-purple-50"
//             >
//               Add Custom Document
//             </button>
//           </div>
//         )}

//         {uploads.length > 0 && (
//           <div className="space-y-4">
//             {uploads.map((upload, index) => (
//               <div
//                 key={upload.id}
//                 className="border border-purple-400 shadow-md rounded-lg transition-all"
//               >
//                 {/* Document header */}
//                 <div className="p-4 flex justify-between items-center">
//                   <div className="flex-1">
//                     {/* Title */}
//                     {upload.editableTitle && canEditDocument(index) ? (
//                       <input
//                         id={`title-input-${index}`}
//                         type="text"
//                         value={upload.title}
//                         onChange={(e) =>
//                           handleTitleChange(index, e.target.value)
//                         }
//                         onBlur={() => handleBlur(index, "editableTitle")}
//                         className="border border-purple-300 px-3 py-1 rounded-md w-full font-medium focus:outline-none focus:ring-2 focus:ring-purple-500"
//                         autoFocus
//                         onClick={(e) => e.stopPropagation()}
//                       />
//                     ) : (
//                       <h3
//                         className={`font-medium ${
//                           upload.file || upload.fileUrl
//                             ? "text-green-600"
//                             : "text-gray-700"
//                         }`}
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           if (canEditDocument(index))
//                             enableEditMode(index, "editableTitle");
//                         }}
//                       >
//                         {upload.title}
//                         {(upload.file || upload.fileUrl) && (
//                           <span className="ml-2 text-xs bg-green-100 text-green-600 py-1 px-2 rounded-full">
//                             {upload.file ? "Ready to upload" : "Uploaded"}
//                           </span>
//                         )}
//                         {canEditDocument(index) && (
//                           <span className="ml-2 text-xs text-purple-500 hover:text-purple-700">
//                             (Click to edit)
//                           </span>
//                         )}
//                       </h3>
//                     )}
//                   </div>

//                   {/* Actions */}
//                   <div className="flex items-center space-x-2">
//                     {canDeleteDocument(index) && (
//                       <button
//                         onClick={async (e) => {
//                           e.stopPropagation();
//                           await handleDelete(index);
//                         }}
//                         disabled={isSubmitting}
//                         className={`p-1 rounded-full ${
//                           isSubmitting
//                             ? "text-gray-300 cursor-not-allowed"
//                             : "text-gray-400 hover:text-red-500 hover:bg-red-50"
//                         }`}
//                       >
//                         <X size={16} />
//                       </button>
//                     )}
//                   </div>
//                 </div>

//                 {/* Document content */}
//                 <div className="px-4 pb-4 pt-1">
//                   {/* Description */}
//                   {upload.editableDescription && canEditDocument(index) ? (
//                     <textarea
//                       value={upload.description}
//                       onChange={(e) =>
//                         handleDescriptionChange(index, e.target.value)
//                       }
//                       onBlur={() => handleBlur(index, "editableDescription")}
//                       className="border border-purple-300 px-3 py-2 rounded-md w-full text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
//                       autoFocus
//                       rows={2}
//                       onClick={(e) => e.stopPropagation()}
//                     />
//                   ) : (
//                     <p
//                       className="text-sm text-gray-600 mb-3"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         if (canEditDocument(index))
//                           enableEditMode(index, "editableDescription");
//                       }}
//                     >
//                       {upload.description}
//                       {canEditDocument(index) && (
//                         <span className="ml-2 text-xs text-purple-500 hover:text-purple-700">
//                           {upload.editableDescription ? "" : "(Click to edit)"}
//                         </span>
//                       )}
//                     </p>
//                   )}

//                   {/* Upload component */}
//                   <DocumentUpload
//                     title={upload.title}
//                     description={upload.description}
//                     index={index}
//                     onFileChange={handleFileChange}
//                     uploadedFile={upload.file}
//                     fileUrl={upload.fileUrl}
//                   />
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}

//         {/* Actions */}
//         <div className="mt-6 flex items-center justify-between">
//           <div className="flex items-center space-x-3">
//             {uploads.length > 0 && !showDefaultDocs && (
//               <button
//                 onClick={addDefaultDocuments}
//                 className="flex items-center text-blue-600 hover:text-blue-800 font-medium text-sm"
//               >
//                 <Plus size={18} className="mr-1" />
//                 Add Required Documents
//               </button>
//             )}
//             {uploads.length > 0 && (
//               <button
//                 onClick={handleAddMore}
//                 className="flex items-center text-purple-600 hover:text-purple-800 font-medium text-sm"
//               >
//                 <Plus size={18} className="mr-1" />
//                 Add more documents
//               </button>
//             )}
//           </div>

//           <button
//             onClick={handleSubmit}
//             disabled={isSubmitting || uploads.length === 0}
//             className={`px-6 py-2 rounded-md text-white font-medium flex items-center ${
//               isSubmitting || uploads.length === 0
//                 ? "bg-purple-400 cursor-not-allowed"
//                 : "bg-purple-600 hover:bg-purple-700"
//             }`}
//           >
//             {isSubmitting ? (
//               <>
//                 <svg
//                   className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
//                   xmlns="http://www.w3.org/2000/svg"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                 >
//                   <circle
//                     className="opacity-25"
//                     cx="12"
//                     cy="12"
//                     r="10"
//                     stroke="currentColor"
//                     strokeWidth="4"
//                   ></circle>
//                   <path
//                     className="opacity-75"
//                     fill="currentColor"
//                     d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                   ></path>
//                 </svg>
//                 Uploading...
//               </>
//             ) : (
//               <>
//                 <Upload size={18} className="mr-2" />
//                 Submit Documents
//               </>
//             )}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FinalDocumentUpload;
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uploadDocuments } from "../../../services/user.services";
import { retrieveStudentDetails } from "../../../services/admin.services";
import { setUserDetails } from "../../../state/reducers/userSlice";
import { Check, File, Plus, Upload, X } from "lucide-react";

// ✅ ADDED: Import WebSocket provider
import { useWebSocket } from "../../../state/reducers/WebSocketProvider";

const genId = () => `cid_${Date.now()}_${Math.random().toString(36).slice(2)}`;

// Enhanced DocumentUpload component
const DocumentUpload = ({
  title,
  description,
  index,
  onFileChange,
  uploadedFile,
  fileUrl,
}) => {
  const fileInputRef = React.useRef(null);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      onFileChange(index, e.target.files[0]);
    }
  };
  console.log("fileurl", fileUrl);
  return (
    <div className="mt-3">
      <div
        onClick={handleClick}
        className={`border-2 border-dashed rounded-lg p-4 transition-all cursor-pointer
          ${
            uploadedFile || fileUrl
              ? "border-green-500 bg-green-50"
              : "border-gray-300 hover:border-purple-400 bg-white"
          }`}
      >
        <input
          type="file"
          onChange={handleFileChange}
          className="hidden"
          ref={fileInputRef}
        />

        <div className="flex items-center">
          {uploadedFile || fileUrl ? (
            <div className="flex items-center text-green-600">
              <Check size={20} className="mr-2" />
              <span className="font-medium">
                {uploadedFile ? uploadedFile.name : "File uploaded"}
              </span>
            </div>
          ) : (
            <div className="flex flex-col items-center w-full py-3 text-gray-500">
              <Upload size={28} className="mb-2 text-purple-500" />
              <p className="text-sm font-medium">Click to upload {title}</p>
              <p className="text-xs mt-1 text-gray-400">
                PDF, DOC, or DOCX up to 10MB
              </p>
            </div>
          )}
        </div>
      </div>

      {fileUrl && (
        <div className="mt-2">
          <a
            href={fileUrl}
            target="_blank"
            rel="noreferrer"
            className="text-sm text-purple-600 hover:text-purple-800 flex items-center"
          >
            <File size={14} className="mr-1" />
            View uploaded file
          </a>
        </div>
      )}
    </div>
  );
};

const FinalDocumentUpload = () => {
  const user_id = useSelector((state) => state.user.user_id);
  // ✅ REMOVED: const socket = useSelector((state) => state.user.socket);
  const studentDetails = useSelector((state) => state.user.userDetails);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showDefaultDocs, setShowDefaultDocs] = useState(false); // New state to control when to show default docs
  const dispatch = useDispatch();

  // ✅ ADDED: WebSocket provider hooks
  const { sendMessage, getConnectionState } = useWebSocket();
  const roomKey = "final_documents_upload";
  const receiverId =
    studentDetails?.assigned_admins?.assigned_content_writer?.id || null;
  const connectionState = getConnectionState(roomKey, user_id);

  // Initial document templates (not added by default)
  const defaultDocTemplates = [
    { title: "Transcripts", description: "Upload your finalized transcripts." },
    {
      title: "SOP",
      description: "Upload your finalized Statement of Purpose.",
    },
  ];

  // State for uploaded documents - starts empty
  const [uploads, setUploads] = useState([]);

  // Fetch and prepopulate only existing uploaded documents (no defaults)
  useEffect(() => {
    let existingDocs = [];

    if (studentDetails?.final_doc_urls) {
      existingDocs = Object.entries(studentDetails.final_doc_urls).map(
        ([title, doc]) => ({
          id: Math.random(),
          title,
          description: doc.description || "Click to edit description",
          fileUrl: doc.url || null,
          file: null,
          editableTitle: false,
          editableDescription: false,
        })
      );
    }

    // Only set existing documents, no default ones
    setUploads(existingDocs);
  }, [studentDetails?.final_doc_urls]);

  // Function to add default documents when needed
  const addDefaultDocuments = () => {
    const existingTitles = uploads.map((doc) => doc.title);

    const newDefaultDocs = defaultDocTemplates
      .filter((template) => !existingTitles.includes(template.title))
      .map((template) => ({
        id: Math.random(),
        title: template.title,
        description: template.description,
        fileUrl: null,
        file: null,
        editableTitle: false,
        editableDescription: false,
      }));

    if (newDefaultDocs.length > 0) {
      setUploads((prevUploads) => [...newDefaultDocs, ...prevUploads]);
      setShowDefaultDocs(true);
    }
  };

  // Fetch user details and update store
  const getStudentProfile = async () => {
    try {
      const res = await retrieveStudentDetails(user_id);
      dispatch(setUserDetails(res.data));
      return res.data;
    } catch (err) {
      console.log(err);
    }
  };

  // ✅ ADDED: Upload files to chat backend
  const uploadFilesToChat = async (files) => {
    if (!files || files.length === 0) return [];

    try {
      const formData = new FormData();
      const fileArray = Array.isArray(files) ? files : [files];

      fileArray.forEach((file) => {
        formData.append("files", file);
      });

      const roomname = `${roomKey}_${user_id}`;
      formData.append("roomname", roomname);
      formData.append("sender_id", user_id);

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/chat_app/api/upload-files/`,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Chat file upload failed");
      }

      const data = await response.json();
      return data.file_urls || [];
    } catch (error) {
      console.error("❌ Chat file upload error:", error);
      throw error;
    }
  };

  // Add more documents dynamically
  const handleAddMore = () => {
    console.log("Adding custom document...");
    const newId = Math.random();
    const currentLength = uploads.length;

    const newDocument = {
      id: newId,
      title: `Document ${currentLength + 1}`,
      description: "Click to edit description",
      fileUrl: null,
      file: null,
      editableTitle: true,
      editableDescription: true,
    };

    console.log("New document:", newDocument);

    setUploads((prevUploads) => {
      const updated = [...prevUploads, newDocument];
      console.log("Updated uploads after adding custom doc:", updated);
      return updated;
    });

    // Focus on the title input after a short delay to ensure the DOM has updated
    setTimeout(() => {
      const titleInput = document.querySelector(
        `#title-input-${currentLength}`
      );
      if (titleInput) {
        titleInput.focus();
        titleInput.select(); // Also select the text for easier editing
      }
    }, 100); // Increased delay slightly
  };

  // Handle file selection
  const handleFileChange = (index, file) => {
    setUploads((prevUploads) =>
      prevUploads.map((upload, i) =>
        i === index ? { ...upload, file, fileUrl: null } : upload
      )
    );
  };

  // Handle title change
  const handleTitleChange = (index, newTitle) => {
    setUploads((prevUploads) =>
      prevUploads.map((upload, i) =>
        i === index ? { ...upload, title: newTitle } : upload
      )
    );
  };

  // Handle description change
  const handleDescriptionChange = (index, newDescription) => {
    setUploads((prevUploads) =>
      prevUploads.map((upload, i) =>
        i === index ? { ...upload, description: newDescription } : upload
      )
    );
  };

  // Enable edit mode - allow editing for non-default docs or if default docs are editable
  const enableEditMode = (index, field) => {
    const isDefaultDoc = defaultDocTemplates.some(
      (template) => template.title === uploads[index]?.title
    );

    // Allow editing if it's not a default doc, or if you want to allow editing default docs
    if (!isDefaultDoc || showDefaultDocs) {
      setUploads((prevUploads) =>
        prevUploads.map((upload, i) =>
          i === index ? { ...upload, [field]: true } : upload
        )
      );

      // For title edits, focus on the input after a short delay
      if (field === "editableTitle") {
        setTimeout(() => {
          const titleInput = document.querySelector(`#title-input-${index}`);
          if (titleInput) {
            titleInput.focus();
          }
        }, 50);
      }
    }
  };

  // Exit edit mode
  const handleBlur = (index, field) => {
    setUploads((prevUploads) =>
      prevUploads.map((upload, i) =>
        i === index ? { ...upload, [field]: false } : upload
      )
    );
  };

  const handleDelete = async (index) => {
    const documentToDelete = uploads[index];

    if (!documentToDelete.fileUrl) {
      // just remove from local state
      setUploads((prevUploads) => prevUploads.filter((_, i) => i !== index));
      return;
    }

    try {
      setIsSubmitting(true);

      const formData = new FormData();
      formData.append("document_type", "final_doc");
      formData.append("action", "delete");
      formData.append("document_key", documentToDelete.title);

      const res = await uploadDocuments(formData);
      setSuccessMessage("Document deleted successfully!");

      const updatedDetails = await getStudentProfile();
      resetUploadState(updatedDetails);
      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (error) {
      console.error("Error deleting document:", error);
      setSuccessMessage("Failed to delete document.");
      setTimeout(() => setSuccessMessage(""), 3000);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Handle form submission
  const handleSubmit = async () => {
    // Use the simpler validation from the first version
    if (uploads.every((upload) => !upload.file)) {
      setSuccessMessage(
        "Please upload at least one new document before submitting."
      );
      setTimeout(() => setSuccessMessage(""), 3000);
      return;
    }

    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("document_type", "final_doc");

    // Add extra validation to prevent null/undefined values
    uploads.forEach((upload) => {
      if (upload.file && upload.title && upload.description) {
        formData.append("document_key", upload.title);
        formData.append("files", upload.file);
        formData.append("description", upload.description);
      }
    });

    try {
      const res = await uploadDocuments(formData);
      setSuccessMessage("Documents uploaded successfully!");
      console.log("Upload Successful:", res);

      // ✅ ADDED: Upload to chat and send WebSocket message
      const filesToUpload = uploads.filter((upload) => upload.file);
      if (
        filesToUpload.length > 0 &&
        receiverId &&
        connectionState?.status === "connected"
      ) {
        try {
          const filesToChat = filesToUpload.map((upload) => upload.file);
          const chatFileUrls = await uploadFilesToChat(filesToChat);

          if (chatFileUrls && chatFileUrls.length > 0) {
            const documentTitles = filesToUpload
              .map((upload) => upload.title)
              .join(", ");

            sendMessage(roomKey, user_id, {
              message: `✅ Final documents uploaded: ${documentTitles}`,
              sender_id: user_id,
              receiver_id: receiverId,
              client_message_id: genId(),
              file_urls: chatFileUrls,
            });
          }
        } catch (chatError) {
          console.error("Chat upload failed:", chatError);
          // Don't fail the whole upload if chat fails
        }
      }

      // Refresh Redux state and reset UI
      const updatedDetails = await getStudentProfile();
      resetUploadState(updatedDetails);

      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (error) {
      console.error("Error:", error);
      setSuccessMessage("Failed to upload documents.");
      setTimeout(() => setSuccessMessage(""), 3000);
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetUploadState = (updatedDetails) => {
    let existingDocs = [];

    if (updatedDetails?.final_doc_urls) {
      existingDocs = Object.entries(updatedDetails.final_doc_urls).map(
        ([title, doc]) => ({
          id: Math.random(),
          title,
          description: doc.description || "Click to edit description",
          fileUrl: doc.url || null,
          file: null,
          editableTitle: false,
          editableDescription: false,
        })
      );
    }

    // Only set existing documents, no defaults
    setUploads(existingDocs);
    setShowDefaultDocs(false);
  };

  const canDeleteDocument = (index) => {
    return true;
  };

  const canEditDocument = (index) => {
    return true;
  };

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
      {/* Header */}
      <div className="bg-purple-600 px-6 py-4">
        <h2 className="text-2xl font-bold text-white">
          Final Documents Upload
        </h2>
        <p className="text-purple-100 text-sm mt-1">
          Upload your finalized admission documents
        </p>
      </div>

      {/* Success message */}
      {successMessage && (
        <div
          className={`px-6 py-3 mt-4 mx-6 rounded-md ${
            successMessage.includes("Failed")
              ? "bg-red-100 text-red-700"
              : "bg-green-100 text-green-700"
          }`}
        >
          {successMessage}
        </div>
      )}

      {/* Documents list */}
      <div className="p-6">
        {/* Add default documents button - only show if no documents exist */}
        {uploads.length === 0 && (
          <div className="text-center py-8 border-2 border-dashed border-gray-300 rounded-lg mb-6">
            <p className="text-gray-500 mb-4">No documents uploaded yet</p>
            <button
              onClick={(e) => {
                e.preventDefault();
                console.log("Default docs button clicked");
                addDefaultDocuments();
              }}
              className="bg-purple-600 text-white px-4 py-2 rounded-md hover:bg-purple-700 mr-3"
            >
              Add Required Documents (Transcripts & SOP)
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                console.log("Custom doc button clicked");
                handleAddMore();
              }}
              className="border border-purple-600 text-purple-600 px-4 py-2 rounded-md hover:bg-purple-50"
            >
              Add Custom Document
            </button>
          </div>
        )}

        {uploads.length > 0 && (
          <div className="space-y-4">
            {uploads.map((upload, index) => (
              <div
                key={upload.id}
                className="border border-purple-400 shadow-md rounded-lg transition-all"
              >
                {/* Document header */}
                <div className="p-4 flex justify-between items-center">
                  <div className="flex-1">
                    {/* Title */}
                    {upload.editableTitle && canEditDocument(index) ? (
                      <input
                        id={`title-input-${index}`}
                        type="text"
                        value={upload.title}
                        onChange={(e) =>
                          handleTitleChange(index, e.target.value)
                        }
                        onBlur={() => handleBlur(index, "editableTitle")}
                        className="border border-purple-300 px-3 py-1 rounded-md w-full font-medium focus:outline-none focus:ring-2 focus:ring-purple-500"
                        autoFocus
                        onClick={(e) => e.stopPropagation()}
                      />
                    ) : (
                      <h3
                        className={`font-medium ${
                          upload.file || upload.fileUrl
                            ? "text-green-600"
                            : "text-gray-700"
                        }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (canEditDocument(index))
                            enableEditMode(index, "editableTitle");
                        }}
                      >
                        {upload.title}
                        {(upload.file || upload.fileUrl) && (
                          <span className="ml-2 text-xs bg-green-100 text-green-600 py-1 px-2 rounded-full">
                            {upload.file ? "Ready to upload" : "Uploaded"}
                          </span>
                        )}
                        {canEditDocument(index) && (
                          <span className="ml-2 text-xs text-purple-500 hover:text-purple-700">
                            (Click to edit)
                          </span>
                        )}
                      </h3>
                    )}
                  </div>

                  {/* Actions */}
                  <div className="flex items-center space-x-2">
                    {canDeleteDocument(index) && (
                      <button
                        onClick={async (e) => {
                          e.stopPropagation();
                          await handleDelete(index);
                        }}
                        disabled={isSubmitting}
                        className={`p-1 rounded-full ${
                          isSubmitting
                            ? "text-gray-300 cursor-not-allowed"
                            : "text-gray-400 hover:text-red-500 hover:bg-red-50"
                        }`}
                      >
                        <X size={16} />
                      </button>
                    )}
                  </div>
                </div>

                {/* Document content */}
                <div className="px-4 pb-4 pt-1">
                  {/* Description */}
                  {upload.editableDescription && canEditDocument(index) ? (
                    <textarea
                      value={upload.description}
                      onChange={(e) =>
                        handleDescriptionChange(index, e.target.value)
                      }
                      onBlur={() => handleBlur(index, "editableDescription")}
                      className="border border-purple-300 px-3 py-2 rounded-md w-full text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
                      autoFocus
                      rows={2}
                      onClick={(e) => e.stopPropagation()}
                    />
                  ) : (
                    <p
                      className="text-sm text-gray-600 mb-3"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (canEditDocument(index))
                          enableEditMode(index, "editableDescription");
                      }}
                    >
                      {upload.description}
                      {canEditDocument(index) && (
                        <span className="ml-2 text-xs text-purple-500 hover:text-purple-700">
                          {upload.editableDescription ? "" : "(Click to edit)"}
                        </span>
                      )}
                    </p>
                  )}

                  {/* Upload component */}
                  <DocumentUpload
                    title={upload.title}
                    description={upload.description}
                    index={index}
                    onFileChange={handleFileChange}
                    uploadedFile={upload.file}
                    fileUrl={upload.fileUrl}
                  />
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Actions */}
        <div className="mt-6 flex items-center justify-between">
          <div className="flex items-center space-x-3">
            {uploads.length > 0 && !showDefaultDocs && (
              <button
                onClick={addDefaultDocuments}
                className="flex items-center text-blue-600 hover:text-blue-800 font-medium text-sm"
              >
                <Plus size={18} className="mr-1" />
                Add Required Documents
              </button>
            )}
            {uploads.length > 0 && (
              <button
                onClick={handleAddMore}
                className="flex items-center text-purple-600 hover:text-purple-800 font-medium text-sm"
              >
                <Plus size={18} className="mr-1" />
                Add more documents
              </button>
            )}
          </div>

          <button
            onClick={handleSubmit}
            disabled={isSubmitting || uploads.length === 0}
            className={`px-6 py-2 rounded-md text-white font-medium flex items-center ${
              isSubmitting || uploads.length === 0
                ? "bg-purple-400 cursor-not-allowed"
                : "bg-purple-600 hover:bg-purple-700"
            }`}
          >
            {isSubmitting ? (
              <>
                <svg
                  className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Uploading...
              </>
            ) : (
              <>
                <Upload size={18} className="mr-2" />
                Submit Documents
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FinalDocumentUpload;
